import TaskDashboardImage from 'public/assets/img/task-dashboard.svg';
import TemplateSubmissionDashboard from 'public/assets/img/template-submission-dashboard.svg';
import ScheduleReportDashboard from 'public/assets/img/schedule-report.svg';
import LocationDashboard from 'public/assets/img/location-dashboard.svg';
import ScoreDashboard from 'public/assets/img/score-dashboard.svg';
export const dashboardImages = {
  'task-summary': TaskDashboardImage,
  'employee-productivity': TemplateSubmissionDashboard,
  'completed-work-report': LocationDashboard,
  'template-submission': ScoreDashboard,
  'schedule-report': ScheduleReportDashboard,
  'template-submissions': ScoreDashboard,
};
